module.exports = __webpack_public_path__ + "img/damnn_group_header.f5fa9478.png";